import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from "@/views/Index";
import Map from "@/views/map/Map";
import Galleries from "@/views/line_chart/Galleries";
import SpecialArea from "@/views/line_chart/SpecialArea";
import SpecialCounter from "@/views/line_chart/SpecialCounter";
import Ranking1 from "@/views/assembly/Ranking1";
import Ranking2 from "@/views/assembly/Ranking2";
import Ranking3 from "@/views/assembly/Ranking3";
import MouthRanking1 from "@/views/assembly/MouthRanking1";
import MouthRanking2 from "@/views/assembly/MouthRanking2";
import MouthRanking3 from "@/views/assembly/MouthRanking3";
import Consumption1 from "@/views/consumption/Consumption1";
import Consumption2 from "@/views/consumption/Consumption2";
import Consumption3 from "@/views/consumption/Consumption3";
import Arrondi from "@/views/Arrondi";
import Arrondi2 from "@/views/Arrondi2";
import Bing1 from "@/views/zhuanqu/Bing1";
import Special from "@/views/Special";
import Special2 from "@/views/Special2";
import SpecialCoun from "@/views/SpecialCoun";
import SpecialCoun2 from "@/views/SpecialCoun2";
import Login from "@/views/Login";
import Information from "@/views/Information";
import Test from "@/views/Test";

Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    name: '首页',
    component: Index
  },
  {
    path: '/map',
    name: '首页地图',
    component: Map
  },
  {
    path: '/SpecialArea',
    name: '专区折线',
    component: SpecialArea
  },
  {
    path: '/galleries',
    name: '专馆折线',
    component: Galleries
  },

  {
    path: '/SpecialCounter',
    name: '专柜折线',
    component: SpecialCounter
  },
  {
    path: '/Ranking1',
    name: '专区消费排行',
    component: Ranking1
  },
  {
    path: '/Ranking2',
    name: '专馆消费排行',
    component: Ranking2
  },
  {
    path: '/Ranking3',
    name: '专柜消费排行',
    component: Ranking3
  },
  {
    path: '/MouthRanking1',
    name: '专区月消费排行',
    component: MouthRanking1
  },
  {
    path: '/MouthRanking2',
    name: '专馆月消费排行',
    component: MouthRanking2
  },
  {
    path: '/MouthRanking3',
    name: '专柜月消费排行',
    component: MouthRanking3
  },
  {
    path: '/Consumption1',
    name: '专区实时消费排行',
    component: Consumption1
  },
  {
    path: '/Consumption2',
    name: '专馆实时消费排行',
    component: Consumption2
  },
  {
    path: '/Consumption3',
    name: '专柜实时消费排行',
    component: Consumption3
  },
  {
    path: '/Arrondi',
    name: '个人居委帮扶列表',
    component: Arrondi
  },
  {
    path: '/Arrondi2',
    name: '文化帮扶列表',
    component: Arrondi2
  },
  // {
  //   path: '/Bing',
  //   name: '个人居委帮扶列表',
  //   component: Bing1
  // },
  {
    path: '/Special',
    name: '专管',
    component: Special
  },

  {
    path: '/Special2',
    name: '咱们店',
    component: Special2
  },

  
  {
    path: '/SpecialCoun',
    name: '专柜',
    component: SpecialCoun
  },
  {
    path: '/SpecialCoun2',
    name: '智慧农业',
    component: SpecialCoun2
  },
  {
    path: '/Login',
    name: '登录',
    component: Login
  },
  {
    path: '/Information',
    name: '信息数据展示',
    component: Information
  },
  // {
  //   path: '/test',
  //   name: '信息数据展示',
  //   component: Test
  // },





]

const router = new VueRouter({
  mode:"history",
  routes
})

export default router
